import { useWallets } from "api/wallets";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { useState } from "react";
import { CampaignConditionNewFormat } from "types/campaigns";

interface Props {
  fieldKey: string;
  ruleData: CampaignConditionNewFormat;
}

export const WalletParam = ({ fieldKey, ruleData }: Props) => {
  const { message } = useMessage();
  const [walletTypeSearch, setWalletTypeSearch] = useState("");
  const { useInfiniteWalletsList } = useWallets();
  const {
    data: infiniteWalletsList,
    size: walletsSize,
    setSize: setWalletsSize,
    isValidating,
  } = useInfiniteWalletsList({
    filters: walletTypeSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: walletTypeSearch,
          },
          {
            condition: "eq",
            query: "active",
            value: true,
          },
        ]
      : [
          {
            condition: "eq",
            query: "active",
            value: true,
          },
        ],
    order: "asc",
    sortKey: "name",
  });
  const { infiniteData: walletsList, anyElementsToFetch: anyWalletsToFetch } =
    useManageInfiniteScroll(infiniteWalletsList || []);

  return (
    <SelectInput
      displaySearch
      data-test-id="wallet"
      items={walletsList.map((wallet) => ({
        label: wallet.name,
        id: wallet.code,
      }))}
      label={<RequiredFieldLabel text={message({ id: "walletType" })} />}
      name={`${fieldKey}.value.params.walletTypeCode`}
      placeholder={message({
        id: "walletType",
      })}
      asyncSearch={(searchedQuery) => setWalletTypeSearch(searchedQuery)}
      initialValue={{
        id: ruleData.value.params?.walletTypeCode,
        label: walletsList.find(
          (wallet) => wallet.code === ruleData.value.params?.walletTypeCode,
        )?.name as string,
      }}
      loadMoreElements={() => !isValidating && setWalletsSize(walletsSize + 1)}
      anyElementsToFetch={anyWalletsToFetch}
    />
  );
};
